
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.975 8.475a.975.975 0 100-1.95.975.975 0 000 1.95zM9.975 3.95a.975.975 0 100-1.95.975.975 0 000 1.95zM9.975 13a.975.975 0 100-1.95.975.975 0 000 1.95zM5.975 8.475a.975.975 0 100-1.95.975.975 0 000 1.95zM5.975 3.95a.975.975 0 100-1.95.975.975 0 000 1.95zM5.975 13a.975.975 0 100-1.95.975.975 0 000 1.95z","fill":"#4A4A4A"}})])
          )
        }
      }
    